import { useState } from "react"
import ItemList from "./ItemList"
const RestaurantCategory = ({
  item,
  showItem,
  setShowItem
}) => {
  console.log("showITEM", showItem)
  console.log("setShowItem", setShowItem)
  return (
    <div className="bg-amber-200 p-2 w-6/12 m-2 rounded hover:bg-amber-100 shadow-lg ml-64 ">
      <div
        className="flex justify-between cursor-pointer "
        onClick={() => setShowItem()}
      >
        <h1 className="">{item?.card.card.title}</h1>
        <span>🔽</span>
      </div>
      {showItem && <ItemList item={item} />}
    </div>
  )
}
export default RestaurantCategory
